import TestIds from 'util/TestIds'
import Loading from 'core/Loading'
import useDocumentTitle from 'hooks/useDocumentTitle'
import EntryFormCard from '../EntryFormCard'

const LoginSSOScene = (): JSX.Element => {
  useDocumentTitle('Login SSO')
  return (
    <EntryFormCard prompt={'Redirecting'} data-testid={TestIds.login.view.sso}>
      <div className="content-center justify-center p-2">
        <p className="typography-body-l my-2 text-center text-neutral-800" data-testid={TestIds.login.label.sso}>
          Redirecting you to your school&apos;s login page
        </p>
      </div>
      <Loading loading={true} />
    </EntryFormCard>
  )
}

export default LoginSSOScene
